export function ModalMessageComponent() {
  return null;
}
